$(window).load(function(){
  window.productItemColor = {
    'Aloe': '#a9d08f',
    'Army': '#8e735e',
    'Ash Grey SF': '#cddbcf',
    'Asphalt': '#262626',
    'Baby Blue': '#91bee9',
    'Beige': '#d1b98d',
    'Black': '#000000',
    'BlackWhite': '#000000',
    'Blue': '#0066ce',
    'Blue Spruce': '#00769e',
    'Blush': '#ffcdea',
    'Brown': '#723100',
    'Burgundy': '#590000',
    'Burnt Orange': '#c55910',
    'Camel': '#864a12',
    'Carbon': '#404040',
    'Cardinal': '#96002a',
    'Charcoal': '#393939',
    'Cobalt': '#0166ff',
    'Copper': '#c55911',
    'Coral': '#ff5960',
    'Cream': '#fffdd0',
    'Dark Brown': '#311500',
    'Dark Green': '#385624',
    'Dark Grey': '#3a3839',
    'Dark Navy': '#203763',
    'Dark Red': '#c00000',
    'Denim': '#203763',
    'Ebony': '#000000',
    'Eggplant': '#552a5c',
    'Emerald': '#009900',
    'Forest': '#034100',
    'Gold': '#efa101',
    'Graphite': '#3a3839',
    'Green Lapis': '#00b050',
    'Green': '#00b133',
    'Grey Navy': '#222b35',
    'Grey Truffle': '#6d323a',
    'Grey': '#928f98',
    'Heather Black': '#404040',
    'Heather Galapagos Blue': '#00b1f1',
    'Heather Grey': '#d9d9d9',
    'Heather Navy': '#203763',
    'Heather Red': '#ff3334',
    'HthrBlackBlack': '#525252',
    'Indigo': '#2d2d87',
    'Iron': '#757170',
    'Ivory': '#fffff3',
    'Jade': '#339967',
    'Juniper': '#2a8156',
    'Kelly Green': '#0a8249',
    'Khaki': '#fedcb9',
    'Lapis': '#23377c',
    'Lavender': '#bfb0d6',
    'Leaf': '#538234',
    'Lemon': '#fff700',
    'Lieutenant': '#67695a',
    'Light Black': '#161616',
    'Light Blue': '#79d4ff',
    'Light Brown': '#b5662c',
    'Light Green': '#78ff71',
    'Light Grey': '#c4c4c4',
    'Light Navy': '#000080',
    'Light Pink': '#ffb6c1',
    'Light Red': '#bf0000',
    'Lilac': '#cc99fe',
    'Lime': '#cff2dc',
    'Loden': '#578200',
    'Maroon': '#800000',
    'Mauve': '#dac0c4',
    'Mint': '#98ff98',
    'Mustard': '#dea500',
    'Navy': '#003448',
    'NeoHtrBlue': '#00b0f0',
    'Neon Green': '#a2e96f',
    'Neon Orange': '#fD5f00',
    'Neon Pink': '#ffa3bc',
    'Neon Yellow': '#e0fc5d',
    'Olive': '#3d4c3a',
    'Onyx': '#000000',
    'Orange': '#e96b19',
    'Orchid': '#cb00cc',
    'Peach': '#f7d0c1',
    'Pewter': '#bfbfbf',
    'Pink': '#ff3d6b',
    'Purple': '#7e5d98',
    'Raspberry': '#bf0076',
    'Red': '#ae001a',
    'Red Navy': '#ff0000',
    'Regatta Blue': '#0094ce',
    'Rose': '#ff339a',
    'Royal': '#0000fe',
    'Royal Blue': '#0662c1',
    'Sangria': '#c9004e',
    'Sapphire': '#0166ff',
    'Sea Foam': '#e0ebe3',
    'Silver': '#bfc8cc',
    'Smoke': '#3a3839',
    'Steel Blue': '#00769e',
    'Tan': '#d2b48c',
    'Tangerine': '#ed7d31',
    'Teal': '#008080',
    'Tropical Blue': '#00ccff',
    'Truffle': '#6d323a',
    'Turquoise': '#00afb1',
    'Violet': '#9933ff',
    'White': '#ffffff',
    'WhiteBlack': '#ffffff',
    'WhiteHthBlack': '#525252',
    'WhiteHthLkeBlu': '#449bac',
    'Wine': '#990134',
    'Yellow': '#f0e000',
  }

  window.searchConfig = {
    facets: {},
    sort: {
      field: undefined,
      direction: undefined
    }
  };

  window.winWidth = parseInt($(window).width(),10);
  window.itemCount = '';
  window.value = '';
  window.oldSearchQuery = null;
  window.oldFacets = null;
  window.newSearchQuery = null;

  // Begin save search history
  const SEARCH_STORAGE_KEY = 'userSearchHistory';

  function getStoredSearchHistory() {
    const stored = localStorage.getItem(SEARCH_STORAGE_KEY);
    if (!stored) return [];

    return JSON.parse(stored);
  }

  function saveSearchTerm(searchTerm) {
    const history = getStoredSearchHistory();

    const newEntry = {
      searchTerm,
      timestamp: Date.now()
    };

    const filteredHistory = history.filter(entry => entry.searchTerm !== searchTerm);
    const updatedHistory = [newEntry, ...filteredHistory].slice(0, 4);

    localStorage.setItem(SEARCH_STORAGE_KEY, JSON.stringify(updatedHistory));
  }
  // End save search history

  // This function returns an array of all url parameters for the current window
  window.getAllUrlParams = function(url) {
    var queryString = url ? url.split('?')[1] : window.location.search.slice(1);
    var obj = {};
    if (queryString) {
      queryString = queryString.split('#')[0];
      var arr = queryString.split('&');
  
      for (var i = 0; i < arr.length; i++) {
        var a = arr[i].split('=');
        var paramName = a[0];
        var paramValue = typeof (a[1]) === 'undefined' ? true : a[1];
        paramName = paramName.toLowerCase();

        if (typeof paramValue === 'string') {
          paramValue = paramValue.toLowerCase();
        }

        if (paramName.match(/\[(\d+)?\]$/)) {
          var key = paramName.replace(/\[(\d+)?\]/, '');

          if (!obj[key]) {
            obj[key] = [];
          } 

          if (paramName.match(/\[\d+\]$/)) {
            var index = /\[(\d+)\]/.exec(paramName)[1];
            obj[key][index] = paramValue;
          } else {
            obj[key].push(paramValue);
          }
        } else {
          if (!obj[paramName]) {
            obj[paramName] = paramValue;
          } else if (obj[paramName] && typeof obj[paramName] === 'string'){
            obj[paramName] = [obj[paramName]];
            obj[paramName].push(paramValue);
          } else {
            obj[paramName].push(paramValue);
          }
        }
      }
    }
    return obj;
  }

  window.customRenderFunction = function(document_type, item) {
    let title = item['title'].split('|')[0].trim();
    let image = item['image'] || '/placeholder.jpg';
    let url = item['url'];
    let price = typeof item['price'] === 'number' ? `$${item['price'].toFixed(2)}` : '';
    let labels = '';
    if (item.quick_ship && item.quick_ship == 1) {
      labels += '<span class="quick-ship">QUICK SHIP</span>';
    }

    return `
      <div class="col-xs-12 col-sm-6 col-md-3 col-lg-3 no-padding collection-product-list">
        <div class="product-list-inner">
          <div class="product-area clearfix">
            <div class="product-info search-product-info">
              <div>
                ${labels}
                <div class="product-thumbnail">
                  <a href="${url}" id="${title}">
                    <img loading="lazy" src="${image}" alt="${title}" width="210" height="210" />
                  </a>
                </div>
              </div>
              <div class="product-info-wrap">
                <div class="price">
                  <span class="product-price">${price}</span><span class="msrp">MSRP</span>
                </div>
                <h4><a href="${url}" id="${title}">${title}</a></h4>
              </div>
            </div>
            <div class="sep"></div>
          </div>
        </div>
      </div>
    `;
  };

  window.$facetContainer = $('.st-dynamic-facets');

  window.reloadResults = function() {
    dbCnvrtCurrent();
    $('#st-results-container2').empty();
    $(window).hashchange(); // This hashchange is required for the search results to refresh
  };

  window.bindControls = function(data) {
    $('html, body').animate({ scrollTop: 0 }, 'fast');
    dbCnvrtCurrent();

    var totalResultCount = 0;
    var $resultContainer = this.getContext().resultContainer;
    var spellingSuggestion = null;

    window.urlHash = location.hash.split('&');
    window.urlQuery = window.urlHash[0];
    var
      resultInfo = data['info'],
      str = '',
      facets = '';

    window.isSearchSubmitted = false;

    var totalNumPages = resultInfo['page']['num_pages'];
    var totalResults = resultInfo['page']['total_result_count'];
    window.newSearchQuery = resultInfo['page']['query'];

    $('.clearfix.product-filter').first().find('.search-results-count').remove();
    $('#mobile-search-count').find('.search-results-count').remove();

    if (totalResults > 0) {
      totalResults = totalResults >= 4800 ? '4800+' : totalResults;
      var resultsCountHTML = '<div class="search-results-count">' + totalResults + ' Product Results</div>';
      if ($(window).width() > 768) {
        $('.clearfix.product-filter').first().append(resultsCountHTML);
      } else {
        $('#mobile-search-count').append(resultsCountHTML);
      }
      updateSearchCounts(totalResults);
    }

    if( totalResults <= 15 && totalNumPages < 2){
      location.hash = window.urlQuery + "&stp=" + totalNumPages;
    }

      $.each(resultInfo, function(documentType, typeInfo){

        totalResultCount += typeInfo['total_result_count'];

        if ( typeInfo['spelling_suggestion'] ) {
          spellingSuggestion = typeInfo['spelling_suggestion']['text'];
        }

        if (totalResultCount === 0 ) {
          $('#search-count').text('/ No results');
          $resultContainer.html(`
            <div class="no-merch">
              <h2>Oops! No merch found.</h2>
              <p>It’s not an e-merch-ancy. Try adjusting your search.</p>
            </div>
          `);
        }

        if (spellingSuggestion !== null) {
          $resultContainer.append('<div class="st-spelling-suggestion alert alert-info mb0 text-center col-sm-12">Did you mean <a href="#" data-hash="true" data-spelling-suggestion="' + spellingSuggestion + '">' + spellingSuggestion + '</a>?</div>');
        }

        /********************** Render facets based on user queries *********************/
        var tempFacets;
        if( window.oldSearchQuery == window.newSearchQuery && (window.oldFacets != null && window.oldFacets != '') ){
          tempFacets = window.oldFacets;
        }else{
          window.oldFacets = typeInfo.facets;
          tempFacets = typeInfo.facets;
          window.oldSearchQuery = window.newSearchQuery;

        }

        var facetNo = 0;
        const desiredFacetOrder = ['style', 'color', 'brand', 'material', 'quick_ship'];

        desiredFacetOrder.forEach(function(field) {
          if (tempFacets.hasOwnProperty(field)) {
            const facetCounts = tempFacets[field];
            facetNo++;

            var str = (field === 'quick_ship') ? 'quick ship' : field;
            var filterTitle = str;
            var facetFound = 0;
            var quick_ship_flag = 0;
            var tempfacets = '';

            var filterSecClass = ($('.foption_box_' + facetNo).length > 0 && $('.foption_box_' + facetNo).is(':visible')) ? '' : 'hide-section';
            var arrowSecClass = ($('.foption_box_' + facetNo).length > 0 && $('.foption_box_' + facetNo).is(':visible')) ? 'slider-arrow-active' : '';

            tempfacets += [
              '<li class="clearfix filter">',
              '<a class="filterTitle" href="javascript:void(0)">', filterTitle, '</a>',
              '<a href="javascript:void(0);" class="slider-arrow ', arrowSecClass, '"></a>',
              '<ul class="coll-filter panel-mm foption_box_', facetNo, ' ', filterSecClass, '">',
              '<li><a href="#" class="clear-selection" data-name="', field, '">All</a></li>'
            ].join('');

            $.each(facetCounts, function(label, count) {
              var itemCount = count;
              var status = "";
              var labelStr = "Quick Ship";
              var id = encodeURIComponent(label).toLowerCase();

              if (window.searchConfig.facets[field] && window.searchConfig.facets[field].indexOf(label) > -1) {
                status = 'checked="checked"';
              }

              var value = (label === '1') ? 1 : label;
              var labelDisplay = (label === '1') ? labelStr : label;

              if (count > 0 && parseInt(label, 10) !== quick_ship_flag) {
                tempfacets += '<li class="search-radio"><label for="' + id + '"><input type="checkbox"' + status + ' name="' + field + '" value="' + value + '" id="' + id + '">';
                if (field === 'color') {
                  var product_color = productItemColor[labelDisplay] || '';
                  tempfacets += '<span class="product-filter-label"><span class="product-color" style="background-color:' + product_color + '"></span>' + labelDisplay + '</span> (' + count + ')</label></li>';
                } else {
                  tempfacets += '<span class="product-filter-label">' + labelDisplay + '</span></label> (' + count + ')</li>';
                }
                facetFound++;
              }
            });

            tempfacets += '</ul></li>';

            if (facetFound > 0) {
              facets += tempfacets;
            }
          }
        });

          $facetContainer.html(facets);
      });

    const checkedInputs = document.querySelectorAll('li.search-radio input[type=checkbox]:checked');
    const filterContainers = document.querySelectorAll('.filter-selection');
    const filterWrappers = document.querySelectorAll('.filter-selection-wrap');

    filterContainers.forEach((filterContainer, index) => {
      const filterWrapper = filterWrappers[index];

      if (filterWrapper) {
        Array.from(filterContainer.querySelectorAll('span')).forEach(span => span.remove());
        filterWrapper.style.display = checkedInputs.length > 0 ? 'flex' : 'none';

        checkedInputs.forEach(input => {
          const label = input.nextElementSibling.textContent;
          const value = input.value;
          if (value) {
            const span = document.createElement('span');
            span.textContent = label;
            span.addEventListener('click', () => {
              const matchingInput = document.querySelector(`li.search-radio input[type=checkbox][value="${value}"]`);
              if (matchingInput && matchingInput.checked) {
                matchingInput.checked = false;
                const li = matchingInput.closest('.search-radio');
                if (li) {
                  li.dispatchEvent(new Event('click', { bubbles: true }));
                }
              }

              span.remove();
              if (filterContainer.querySelectorAll('span').length === 0) {
                filterWrapper.style.display = 'none';
              }
            });

            filterContainer.appendChild(span);
          }
        });

        const clearAllBtn = filterWrapper.querySelector('.filter-selection-clearall');
        if (clearAllBtn) {
          clearAllBtn.addEventListener('click', () => {
            const inputs = document.querySelectorAll('li.search-radio input[type=checkbox]:checked');
            inputs.forEach(input => {
              input.checked = false;
              const li = input.closest('.search-radio');
              if (li) {
                li.dispatchEvent(new Event('click', { bubbles: true }));
              }
            });

            filterContainers.forEach((fc, i) => {
              fc.querySelectorAll('span').forEach(span => span.remove());
              filterWrappers[i].style.display = 'none';
            });
          });
        }
      }
    });

    function updateSearchCounts(productCount) {
      const productCountNumber = typeof productCount === 'string' ? Number(productCount.replace(/[^0-9]/g, '')) : productCount;
      const collectionCount = $('#st-search-collections > div:not(.st-no-results)').length;
      const pageCount = $('#st-search-pages > div:not(.st-no-results)').length;
      const totalCount = productCountNumber + collectionCount + pageCount;
      $('#search-count').text(`/ ${totalCount} results`);
      collectionCount > 0 && $('.collectionsTitle').text(`${collectionCount} Related Collections`);
      pageCount > 0 && $('.pagesTitle').text(`${pageCount} Related Pages`);
      pageCount === 0 ? $('.pagesTitle').hide() : $('.pagesTitle').show();
      collectionCount === 0 ? $('.collectionsTitle').hide() : $('.collectionsTitle').show();
    }

    $('#search-term').text('"' + window.newSearchQuery + '"');
    setTimeout(function waitForCollectionsAndPages() {
      const collectionReady = $('#st-search-collections > li').length > 0 || $('.collectionsTitle').is(':visible');
      const pageReady = $('#st-search-pages > li').length > 0 || $('.pagesTitle').is(':visible');
      const productCount = data?.info?.page?.total_result_count > 4800 ? 4800 : data?.info?.page?.total_result_count || 0;

      if (collectionReady || pageReady) {
        updateSearchCounts(productCount);
      } else {
        setTimeout(waitForCollectionsAndPages, 100);
      }
    }, 100);
  };

  window.readSortField = function() {
    return { page: window.searchConfig.sort.field };
  };

  window.readSortDirection = function() {
    return { page: window.searchConfig.sort.direction };
  };

  window.isSearchSubmitted = false;
  window.readFilters = function() {
    var pageFilters = {};

    Object.keys(window.searchConfig.facets).forEach(function(field) {
      var vals = window.searchConfig.facets[field] || [];
      if (vals.length === 0) {
        return;
      }
      if (vals.length > 1) {
        pageFilters[field] = {
          type: 'and',
          values: vals
        };
      } else {
        pageFilters[field] = vals;
      }
    });

    pageFilters['DISCONTINUED'] = 0;
    pageFilters['type'] = 'product';

    return { page: pageFilters };
  };

  window.customOnComplete = function(elem) {
    dbCnvrtCurrent();
    window.location = elem.attr('href');
  };

  window.customAutocompleteDesign = function(document_type, item) {
    const imageUrl = item['image'] && !item['image'].includes('transparentLarge.png')
      ? item['image']
      : 'https://cdn.shopify.com/s/files/1/0312/6537/files/merch-logo.png?v=1747921868';
    if (typeof item['price'] !== 'number') {
      var itemPrice = ''; 
    } else {
      var itemPrice = '$' + parseFloat(item['price']).toFixed(2);
    }
    var out ='';
      out += '<div class="autocompleteListWrapper"><div class="autocompleteItemImage"><img src="'+imageUrl+'" alt=""></div><div class="autocompleteItemTitle"><p class="title">' + item['title'] + '</p></div></div>';
    return out;
  };

  window.footerCustomAutocompleteDesign = function(document_type, item) {
    if (typeof item['price'] !== 'number') {
      var itemPrice = ''; 
    } else {
      var itemPrice = '$' + parseFloat(item['price']).toFixed(2);
    }
    var out ='';
      out += '<div id="footer-autocomplete" class="autocompleteListWrapper"><div class="autocompleteItemImage"><img src="'+item['image']+'" alt=""></div><div class="autocompleteItemTitle"><p class="title">' + item['title'] + '</p></div></div>';
    return out;
  };

  window.customResultRenderFunction = function(ctx, results) {
    const $list = ctx.list;
    const config = ctx.config;

    const products = [];
    const collections = [];
    const pages = [];
    const other = [];

    Object.entries(results).forEach(([_, docs]) => {
      docs.forEach(item => {
        if (item.type === 'product') {
          products.push(item);
        } else if (item.type === 'collection') {
          collections.push(item);
        } else if (item.type === 'page') {
          pages.push(item);
        } else {
          other.push(item);
        }
      });
    });

    let takeCollections = Math.min(2, collections.length);
    let takePages = Math.min(2, pages.length);
    let extraSlots = 4 - (takeCollections + takePages);

    if (extraSlots > 0) {
      const extraCollections = Math.min(extraSlots, collections.length - takeCollections);
      takeCollections += extraCollections;
      extraSlots -= extraCollections;

      const extraPages = Math.min(extraSlots, pages.length - takePages);
      takePages += extraPages;
    }

    const categories = [
      ...collections.slice(0, takeCollections),
      ...pages.slice(0, takePages),
    ];

    const $temp = $('<ul></ul>');

    const createListItem = (item) => {
      return $('<li class="autoCompleteResults" data-type="' + item.type + '">')
        .append('<a href="' + item.url + '">' + config.renderFunction(null, item) + '</a>');
    };

    if (products.length > 0) {
      $temp.append(`
        <div class="spacer-with-line">
          <div class="spacer-line"></div>
        </div>
        <li class="autoCompleteResults categotyTitle">
          <div class="autocompleteListWrapper">
            <div class="autocompleteItemTitle">
              <p class="title">Products</p>
            </div>
          </div>
        </li>
      `);
      products.forEach(item => {
        const $li = createListItem(item);
        ctx.registerResult($li.appendTo($temp), item);
      });
    }

    if (categories.length > 0) {
      $temp.append(`
        <div class="spacer-with-line">
          <div class="spacer-line"></div>
        </div>
        <li class="autoCompleteResults categotyTitle">
          <div class="autocompleteListWrapper">
            <div class="autocompleteItemTitle">
              <p class="title">Categories</p>
            </div>
          </div>
        </li>
      `);
      categories.forEach(item => {
        const $li = createListItem(item);
        ctx.registerResult($li.appendTo($temp), item);
      });
    }

    if (other.length > 0) {
      $temp.append(`
        <div class="spacer-with-line">
          <div class="spacer-line"></div>
        </div>
        <li class="autoCompleteResults categotyTitle">
          <div class="autocompleteListWrapper">
            <div class="autocompleteItemTitle">
              <p class="title">Other</p>
            </div>
          </div>
        </li>
      `);
      other.forEach(item => {
        const $li = createListItem(item);
        ctx.registerResult($li.appendTo($temp), item);
      });
    }

    const searchQuery = ctx.config.inputElement ? ctx.config.inputElement.val() : $('#st-search-input').val();
    const history = getStoredSearchHistory()
      .map(e => e.searchTerm)
      .filter(term => term.toLowerCase() !== searchQuery.toLowerCase());

    if (history.length) {
      $temp.append(`
        <div class="spacer-with-line">
          <div class="spacer-line"></div>
        </div>
        <li class="autoCompleteResults categotyTitle">
          <div class="autocompleteListWrapper">
            <div class="autocompleteItemTitle">
              <p class="title">My Recent Searches</p>
            </div>
          </div>
        </li>
      `);
      history.forEach(term => {
        const $historyItem = $(`
          <li class="autoCompleteResults" data-type="history" data-position="0">
            <a href="#" class="history-search-link">
              <div class="autocompleteListWrapper">
                <div class="autocompleteItemTitle">
                  <p class="title"></p>
                </div>
              </div>
            </a>
          </li>
        `);

        $historyItem
          .find('.history-search-link')
          .attr('data-search', encodeURIComponent(term));
        $historyItem.find('.title').text(term);
        $temp.append($historyItem);
      });
    }

    $list.empty().append($temp.contents());

    if (config.widgetContainerClass && config.widgetContainerClass !== 'swiftype-widget swiftype-widget-footer') {
      stopBodyScroll();
    }

    dbCnvrtCurrent();
  };

  /***********Sort results data in categories *********************/
  function sort_li(a, b){
    return ($(b).data('position')) < ($(a).data('position')) ? 1 : -1;   
  }
  /******************************************************************/

  /************ Footer Dropdown Design *************************/
  var customDropdownStylesFunction = function($this) {
    var config = $this.data('swiftype-config-autocomplete');
    var $attachEl = config.attachTo ? $(config.attachTo) : $this;
    var offset = $attachEl.parent().parent().offset();
    var styles = {
      'position': 'absolute',
      'z-index': 9999,
      'bottom': (($(document).height()  - offset.top)  - ($attachEl.outerHeight()- 60)),
      'left': offset.left
    };
    if (config.setWidth) {
      styles['width'] = $attachEl.parent().parent().outerWidth();
    }
    return styles;
  };
  /*******************************************************************/


    /********************* Header search init ************************************/
    $('#st-search-input').swiftypeSearch({
      resultContainingElement: '#st-results-container2',
      engineKey: 'PYxrpUNc8zBj3chr1cr9',
      renderFunction: customRenderFunction,
      sortField: readSortField,
      sortDirection: readSortDirection,
      facets: { page: ['brand', 'color', 'material', 'style', 'quick_ship'] },
      filters: readFilters,
      postRenderFunction: bindControls,
      perPage: 48,
      onComplete: customOnComplete, 
      spelling: 'strict',
    });
    /*****************************************************************************/

    /********************* Footer search init ************************************/
    $('#footer-search-textinput').change(function(){
     $('#st-search-input').val($('#footer-search-textinput').val());
    //  $('#st-search-input').parents('form').submit(); // when user change footer search and do not submit it. sync to top search
    });
    $('#st-search-input').change(function(){
     $('#footer-search-textinput').val($('#st-search-input').val());
    });
    /*****************************************************************************/

  /********* Header autocomplete search ***************************/
  $('#st-search-input').swiftype({
    engineKey: 'PYxrpUNc8zBj3chr1cr9',
    renderFunction: customAutocompleteDesign,
    resultLimit: 8,
    resultRenderFunction: customResultRenderFunction,
    noResultsMessage: 'Sorry, no results were found. Please try again!',
    filters: { 
      page: {
        'DISCONTINUED': 0,
      }
    },
    autocompleteContainingElement: '.header',
    dropdownStylesFunction: dropdownStylesFunction
  });

  function dropdownStylesFunction($this) {
    var config = $this.data('swiftype-config-autocomplete');
    var $form = $this.closest('.search-form');
    var $horizontalAnchor = $form.closest('.form-container');
    var $list = $this.data('swiftype-list');
    var $positioningContext = $list && $list.length
      ? $list.closest('.swiftype-widget')
      : $(config.autocompleteContainingElement).first();
    var formOffset = $form.offset();
    var horizontalOffset = $horizontalAnchor.offset();
    var contextOffset = $positioningContext.offset();
    var styles = {
      'position': 'absolute',
      'z-index': 9999,
    };
    if (window.innerWidth >= 767 && formOffset && horizontalOffset && contextOffset) {
      styles['left'] = horizontalOffset.left - contextOffset.left;
      styles['top'] = formOffset.top - contextOffset.top + $form.outerHeight();
    }
    if (config.setWidth && $horizontalAnchor.length) {
      styles['width'] = window.innerWidth < 767 ? '100%' : $horizontalAnchor.outerWidth();
    }
    return styles;
  
  };
  /**********************************************************/

  function heroSearchDropdownStylesFunction() {
    return {
      'position': 'absolute',
      'z-index': 9999,
      'top': 0,
      'left': 0,
      'width': '100%'
    };
  };

  function initializeHeroSearchSuggestions() {
    $('.js-hero-search-suggestions').each(function() {
      const $terms = $(this).find('span');
      const termCount = $terms.length;
      let activeIndex = 0;

      function setActiveTerm() {
        $terms.removeClass('is-active is-next is-previous');
        $terms.eq(activeIndex).addClass('is-active');

        if (termCount > 1) {
          $terms.eq((activeIndex + 1) % termCount).addClass('is-next');
          $terms.eq((activeIndex + termCount - 1) % termCount).addClass('is-previous');
        }
      }

      setActiveTerm();

      if (termCount > 1 && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        window.setInterval(function() {
          activeIndex = (activeIndex + 1) % termCount;
          setActiveTerm();
        }, 1200);
      }
    });
  }

  function initializeHeroSearch() {
    $('.js-hero-search-input').each(function() {
      const $input = $(this);
      const $form = $input.closest('[data-hero-search-form]');
      let closeTimeout;

      function showHeroSearchDropdown() {
        window.clearTimeout(closeTimeout);
        $form
          .removeClass('hero-search__search-form--autocomplete-closing')
          .addClass('hero-search__search-form--autocomplete-active');

        window.requestAnimationFrame(function() {
          $form.addClass('hero-search__search-form--autocomplete-open');
        });
      }

      $input.swiftype({
        engineKey: 'PYxrpUNc8zBj3chr1cr9',
        inputElement: $input,
        renderFunction: customAutocompleteDesign,
        resultLimit: 8,
        resultRenderFunction: customResultRenderFunction,
        noResultsMessage: 'Sorry, no results were found. Please try again!',
        filters: {
          page: {
            'DISCONTINUED': 0,
          }
        },
        autocompleteContainingElement: $form,
        dropdownStylesFunction: heroSearchDropdownStylesFunction
      });

      $form.on('submit', function(e) {
        e.preventDefault();

        const query = $input.val().trim();
        if (query) {
          saveSearchTerm(query);
          window.location = '/pages/search-results#stq=' + encodeURIComponent(query);
        }
      });

      $input.on('focus', function() {
        const history = getStoredSearchHistory();
        const $list = $input.data('swiftype-list');

        if (!history.length || !$list) {
          return;
        }

        $list.empty();
        $list.append(`
          <div class="spacer-with-line">
            <div class="spacer-line"></div>
          </div>
          <li class="autoCompleteResults categotyTitle">
            <div class="autocompleteListWrapper">
              <div class="autocompleteItemTitle">
                <p class="title">My Recent Searches</p>
              </div>
            </div>
          </li>
        `);

        history.forEach(function(entry) {
          const $result = $('<li class="autoCompleteResults history">')
            .append($('<a href="#">').text(entry.searchTerm))
            .on('click', function(e) {
              e.preventDefault();
              saveSearchTerm(entry.searchTerm);
              window.location = '/pages/search-results#stq=' + encodeURIComponent(entry.searchTerm);
            });

          $list.append($result);
        });

        $list.parent().show();
        showHeroSearchDropdown();
      });

      $input.on('blur', function() {
        $form
          .removeClass('hero-search__search-form--autocomplete-active hero-search__search-form--autocomplete-open')
          .addClass('hero-search__search-form--autocomplete-closing');

        closeTimeout = window.setTimeout(function() {
          $form.removeClass('hero-search__search-form--autocomplete-closing');
        }, 180);
      });

      $input.on('input', function() {
        if ($input.val()) {
          showHeroSearchDropdown();
        } else if (!getStoredSearchHistory().length) {
          $form.removeClass('hero-search__search-form--autocomplete-active hero-search__search-form--autocomplete-open');
        }
      });
    });
  };

  initializeHeroSearchSuggestions();
  initializeHeroSearch();

  /********* Footer autocomplete search ***************************/
  $('#footer-search-textinput').swiftype({
    engineKey: 'PYxrpUNc8zBj3chr1cr9',
    renderFunction: footerCustomAutocompleteDesign,
    resultLimit: 7,
    resultRenderFunction: customResultRenderFunction,
    noResultsMessage: 'Sorry, no results were found. Please try again!',
    suggestionListClass: 'footerResults',
    dropdownStylesFunction: customDropdownStylesFunction,
    widgetContainerClass: 'swiftype-widget swiftype-widget-footer',
    filters: { 
      page: {
        'DISCONTINUED': 0,
      }
    },
  });

  $('#footer-search-textinput').swiftypeSearch({
    resultContainingElement: '#st-results-container2',
    engineKey: 'PYxrpUNc8zBj3chr1cr9',
    renderFunction: customRenderFunction,
    sortField: readSortField,
    sortDirection: readSortDirection,
    facets: { page: ['brand', 'color', 'material', 'style', 'quick_ship'] },
    filters: readFilters,
    postRenderFunction: bindControls,
    perPage: 48,
    onComplete: customOnComplete, 
    spelling: 'strict',
  });
  /**********************************************************/

  $('.sort').on('click', function(e){
    e.preventDefault();
    $('.sort').removeClass('active');
    $(this).addClass('active');
    $('#sort-by-list').slideToggle();
    $('.arrow').toggleClass('arrow-active');
    window.searchConfig.sort.field = $(this).data('field');
    window.searchConfig.sort.direction = $(this).data('direction');
    reloadResults();
  });

  $(document).on('click', function(e) {
    const $sortList = $('#sort-by-list');
    const isMobile = $(window).width() < 768;
    const clickedOutside = 
      !$sortList.is(e.target) && 
      $sortList.has(e.target).length === 0;

    if (clickedOutside && !isMobile) {
      $('#sort-by-list').slideUp();
      $('.arrow').removeClass('arrow-active');
      $('body').removeClass('product-shorting-active');
    }
  });

  $facetContainer.on('click', '.search-radio', function(e) {
    $('.sticky-filter-sort').show();
    $('.collection-filter-header').removeClass('hide-before');
    window.searchConfig.facets = {};
    $('.st-dynamic-facets input[type="checkbox"]').each(function() {
      var $cb = $(this),
          field = $cb.prop('name'),
          value = $cb.prop('value');
      if (!$cb.prop('checked')) return;
      window.searchConfig.facets[field] = window.searchConfig.facets[field] || [];
      window.searchConfig.facets[field].push(value);
    });

    var baseHash = window.location.hash.split('&')[0];
    var newHash  = baseHash + "&stp=1";
    if (history.replaceState) {
      history.replaceState(null, '', window.location.pathname + newHash);
    } else {
      window.location.hash = newHash;
    }

    reloadResults();
  });

  $facetContainer.on('click', 'a.clear-selection', function(e) {
    e.preventDefault();
    $('input[name="'+ $(this).data('name') +'"]').prop('checked', false);
    delete window.searchConfig.facets[$(this).data('name')];

    var baseHash = window.location.hash.split('&')[0];
    var newHash  = baseHash + "&stp=1";
    if (history.replaceState) {
      history.replaceState(null, '', window.location.pathname + newHash);
    } else {
      window.location.hash = newHash;
    }

    reloadResults();
  });

  /**** Sidebar dropdown animations *****/
  $('body').on("click", ".st-dynamic-facets .filter", function(e){
      if($(e.target).closest('label').length < 1){
        e.preventDefault();
        $(this).find('ul').slideToggle();
        $(this).find('a.slider-arrow').toggleClass('slider-arrow-active');
      }
  });

  if( winWidth < 768){
    /* Product sort Mobile */
    $('body').on('click', '#sort-by-list li', function (e) {
      $('body').removeClass('active-short');
      $('html').removeClass('scrollHide');

    });

     /* Product filter mobile */
    $('body').on('click', '.st-dynamic-facets .filter .coll-filter label', function (e) {
      $('body').removeClass('active-filter');
      $('html').removeClass('scrollHide');
    });
  }

  var stopBodyScroll = function() {
    var headerHeight = parseInt($('.header').height(), 10);
    var winHeight = parseInt($(window).height(), 10);
    
    if (winWidth < 768) {
      var listHeight = parseInt(winHeight - headerHeight, 10);
      var $autocompleteEls = $('.swiftype-widget .autocomplete').not('.searchBnC');

      if ($('.autoCompleteResults').is(':visible') || $('.new-search-input').val() !== '') {
        $autocompleteEls.css('max-height', listHeight);
      } else {
        $autocompleteEls.css('max-height', 'auto');
      }
    }
  }
  $(window).on('resize', function(){
    stopBodyScroll();
  });

  /************** Header and Footer search form submit actions *************************/

  $('#search-form').submit(function(e){
    e.preventDefault();
    window.isSearchSubmitted = true;
    $("#footer-search-textinput").val('');
    $(".search-form-footer").removeClass('form-open');
    $(".nav .cart-item").addClass('cart-item-hide');
    $('.clearfix.product-filter').first().find('.search-results-count').remove();
    $('#mobile-search-count').find('.search-results-count').remove()
    $('#search-term').empty();
    $('#search-count').empty();
    $('input[type="checkbox"]').prop('checked', false);
    if (window.searchConfig && window.searchConfig.facets) {
      window.searchConfig.facets = {};
    }

    if(typeof window.searchConfig != "undefined"){
      window.searchConfig.sort.field = undefined;
      window.searchConfig.sort.direction = undefined;
    }
    if($('.coll-filter input[type="checkbox"]').length){
      $('.coll-filter input[type="checkbox"]').removeAttr('checked');
    }
    if($('.st-dynamic-facets ul.coll-filter.panel-mm').length){
      $('.st-dynamic-facets ul.coll-filter.panel-mm').hide();
      $('.st-dynamic-facets a.slider-arrow').removeClass('slider-arrow-active');
    }
    $('.sort').removeClass('active');
    var query = $("#st-search-input").val().trim();
    if( query == ''){
      setTimeout(function() { $('#st-results-container2').html('<div id="st-no-results" class="alert alert-warning mb0 st-no-results text-center col-sm-12"><strong>Sorry No Results Found</strong></div>') }, 700);
      return false;
    }else{
      saveSearchTerm(query);
      if(document.getElementById("search-results")){
        //do nothing, Swiftype will handle the event
      }else{
        window.location = "/pages/search-results#stq=" + encodeURIComponent(query);
      }
    }
  });

  $('#footer-search-form').submit(function(e){
    e.preventDefault();
    window.isSearchSubmitted = true;
    $("#st-search-input").val('');
    $(".search-form").removeClass('form-open');
    $(".iconSearch").removeClass('icon_close');
    $(".iconSearch").addClass('icon_search');
    $(".nav .cart-item").removeClass('cart-item-hide');


    if(typeof window.searchConfig != "undefined"){
      window.searchConfig.sort.field = undefined;
      window.searchConfig.sort.direction = undefined;
    }
    if($('.coll-filter input[type="checkbox"]').length){
      $('.coll-filter input[type="checkbox"]').removeAttr('checked');
    }
    if($('.st-dynamic-facets ul.coll-filter.panel-mm').length){
      $('.st-dynamic-facets ul.coll-filter.panel-mm').hide();
      $('.st-dynamic-facets a.slider-arrow').removeClass('slider-arrow-active');
    }
    $('.sort').removeClass('active');
    var query = $("#footer-search-textinput").val();
    if( query == ''){
      setTimeout(function() { $('#st-results-container2').html('<div id="st-no-results" class="alert alert-warning mb0 st-no-results text-center col-sm-12"><strong>Sorry No Results Found</strong></div>') }, 700);
    }else{
      saveSearchTerm(query);
      if(document.getElementById("search-results")){
        //do nothing, Swiftype will handle the event
      }else{
        window.location = "/pages/search-results#stq=" + encodeURIComponent(query);
      }
    }
  });

  /**
   * modifications for search page and rendering Brands(pages) and Collections
   */
  let isRenderBnC = getFiltersBnC();
  if (isRenderBnC) {
    $('#st-search-input').swiftypeSearch({
      resultContainingElement: '#st-search-collections',
      engineKey: 'PYxrpUNc8zBj3chr1cr9',
      renderFunction: renderItemBnC,
      filters: filterBnC('collections'),
      perPage: 4,
    });

    $('#st-search-input').swiftypeSearch({
      resultContainingElement: '#st-search-pages',
      engineKey: 'PYxrpUNc8zBj3chr1cr9',
      renderFunction: renderItemBnC,
      filters: filterBnC('pages'),
      perPage: 4,
    });
  }

  function filterBnC(type) {
    if (!document.querySelector('.searchBnCWrapper')) {
      return false;
    }
    document.querySelector('.searchBnCWrapper').style.display = 'none';
    let isRenderBnC = getFiltersBnC(),
      filterSettingsForCollection = {
        page: {
          'type': 'collection',
        }
      },
      filterSettingsForPage = {
        page: {
          'type': 'page',
        }
      };

    if (isRenderBnC) {
      
      if (type == 'collections') {
        return filterSettingsForCollection;
      } else if (type == 'pages') {
        return filterSettingsForPage;
      }
    } else {
      document.querySelector('.searchBnCWrapper').style.display = 'none';

      return false;
    }
    
  }

  function renderItemBnC(document_type, item) {
    if (item['type'] !== 'product' && getFiltersBnC()) {
      document.querySelector('.searchBnCWrapper').style.display = 'flex';

      const titleSelector = '.' + item['type'] + 'sTitle';
      const titleElement = document.querySelector(titleSelector);
      const rawTitle = typeof item['title'] === 'string' ? item['title'] : '';
      const displayTitle = rawTitle.split('|')[0].trim();

      if (titleElement) {
        titleElement.style.display = 'block';
      }

      if (!item['title']) return '';

      const imageUrl = item['image'] && !item['image'].includes('transparentLarge.png')
        ? item['image']
        : 'https://cdn.shopify.com/s/files/1/0312/6537/files/merch-logo.png?v=1747921868';

      return `
        <div class="search-card" data-type="${item['type']}" data-position="3">
          <a href="${item['url']}" class="search-card-link">
            <div class="search-card-inner">
              <div class="search-card-image">
                <img src="${imageUrl}" alt="${item['title']}">
              </div>
              <div class="search-card-title">
                <p>${displayTitle}</p>
              </div>
            </div>
          </a>
        </div>
      `;
    }
  };

  function getFiltersBnC() {
    let filterNamesArray = ['brand', 'color', 'material', 'style', 'quick_ship'],
      isFilters = false;
    filterNamesArray.forEach(function(filterName) {
      if (window.searchConfig.facets[filterName] && window.searchConfig.facets[filterName].length) {
        isFilters = true;
      }
    });
    if (isFilters) {
      return false;
    } else {
      return true;
    }    
  }

  // Handle click on recent search links
  $('body').on('click', '.history-search-link', function(e) {
    e.preventDefault();
    const searchTerm = decodeURIComponent($(this).data('search'));

    $('#st-search-input').val(searchTerm);
    $('#footer-search-textinput').val(searchTerm);

    saveSearchTerm(searchTerm);

    window.location = '/pages/search-results#stq=' + encodeURIComponent(searchTerm);
  });

  // On the search results page, populate the input with the value from the URL
  function populateSearchInputFromURL() {
    var hash = window.location.hash;
    if (hash.includes('stq=')) {
      var params = new URLSearchParams(hash.replace('#', ''));
      var searchTerm = params.get('stq');
      if (searchTerm) {
        $('#st-search-input').val(decodeURIComponent(searchTerm));
        $('#footer-search-textinput').val(decodeURIComponent(searchTerm));
      }
    }
  }

  if (window.location.pathname.includes('/pages/search-results')) {
    populateSearchInputFromURL();
  }

  // Show recent searches when the input is focused
  (function(){
    var $input = $('#st-search-input');

    $input.on('focus', function(){
      var $list = $input.data('swiftype-list');
      if (!$list) return;

      $list.parent().css(dropdownStylesFunction($input));

      var history = getStoredSearchHistory();
      if (!history.length) return;

      $list.empty();

      const $heading = $(`
        <div class="spacer-with-line">
          <div class="spacer-line"></div>
        </div>
        <li class="autoCompleteResults categotyTitle">
          <div class="autocompleteListWrapper">
            <div class="autocompleteItemTitle">
              <p class="title">My Recent Searches</p>
            </div>
          </div>
        </li>
      `);

      $list.append($heading);

      history.forEach(function(entry){
        var $li = $('<li class="autoCompleteResults history">')
          .append(
            $('<a href="#">').text(entry.searchTerm)
          )
          .on('click', function(e){
            e.preventDefault();
            $input.val(entry.searchTerm);
            saveSearchTerm(entry.searchTerm);
            $('#search-form').trigger('submit');
          });
        $list.append($li);
      });

      $list.parent().show();
    });
  })();

});

window.addEventListener('DOMContentLoaded', function () {
  const hashParams = new URLSearchParams(window.location.hash.slice(1));
  const query = hashParams.get('stq');

  if (query) {
    const input = document.getElementById('st-search-input');
    if (input) {
      input.value = decodeURIComponent(query);
    }
  }
});
